import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(theme => ({
    userListBody: {
        paddingBottom: '4rem',
        minHeight: '50vh',
        position: 'relative',
    },
}));
